import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'
import antmedia from './modules/antmedia'
import cameras from './modules/cameras'
import categories from './modules/categories'
import countries from './modules/countries'
import entities from './modules/entities'
import events from './modules/events'
import files from './modules/files'
import groups from './modules/groups'
import languages from './modules/languages'
import matchEvents from './modules/match-events'
import matches from './modules/matches'
import notifications from './modules/notifications'
import permissions from './modules/permissions'
import phases from './modules/phases'
import pitches from './modules/pitches'
import provinces from './modules/provinces'
import rbpi from './modules/rbpi'
import regions from './modules/regions'
import roles from './modules/roles'
import stadiums from './modules/stadiums'
import stats from './modules/stats'
import subscriptions from './modules/subscriptions'
import teams from './modules/teams'
import tournaments from './modules/tournaments'
import towns from './modules/towns'
import trainings from './modules/trainings'
import typeEvents from './modules/type-events'
import typeSubscriptions from './modules/type-subscriptions'
import users from './modules/users'
import { toast } from './toast.module'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    offset: new Date().getTimezoneOffset() / -60,
  },
  modules: {
    antmedia,
    auth,
    cameras,
    toast,
    roles,
    users,
    languages,
    permissions,
    towns,
    provinces,
    countries,
    categories,
    entities,
    stadiums,
    stats,
    subscriptions,
    tournaments,
    phases,
    groups,
    pitches,
    teams,
    trainings,
    typeEvents,
    typeSubscriptions,
    matches,
    events,
    matchEvents,
    files,
    notifications,
    regions,
    rbpi,
  },
})

export default store
